/* ==========================================================================
   IBT — BO SUNG CHO GIO HANG   (Spec 05 ngan keo · Spec 06 trang /cart)
   Them 17.08.2026 · mo rong 18.08.2026.

   PHAN 1 — NGAN KEO (.halo-cart-sidebar): theme Halo chi co danh sach san pham
   + nut Checkout. Spec 05 doi them khoi khuyen mai, bang tom tat day du va hang
   tin cay -> tat ca do file nay chen vao.

   PHAN 2 — TRANG /cart: trang nay KHONG in ra .halo-cart-sidebar (quirk #10),
   nen khoi tom tat o day duoc dung bang LIQUID trong sections/main-cart.liquid.
   File nay chi lam DUNG HAI viec cho trang do — hai viec ma Liquid khong lam duoc:
     (a) dien khoang NGAY GIAO (phai tinh theo dong ho TRINH DUYET de trung voi
         trang san pham, khong phai mui gio cua hang);
     (b) cap nhat so luong trong tieu de H1 sau khi doi so luong — vi theme.js
         updateCart() CHI ve lai .page-header khi gio TRONG (nhanh else), gio con
         hang thi tieu de dung yen.
   ⛔ KHONG dong vao con so TIEN o trang /cart: tien do Liquid in tu doi tuong
      `cart`, va theme.js tu ve lai .cart-total-subtotal moi lan doi so luong.

   NGUYEN TAC: moi con so deu doc tu /cart.js cua Shopify. KHONG tu tinh giam
   gia, KHONG bia tong tien. Neu Shopify chua ap dung giam gia thi khong hien
   dong giam gia — dung muc 38 "Do not fake discount totals".

   NGAY GIAO: dung DUNG tham so cua khoi delivery_time o trang san pham
   (templates/product.json: d_start 9, d_end 17, exclude_day rong) va dung DUNG
   phep tinh cua assets/delivery-time.js — cong thang so ngay LICH vao hom nay.
   Vi vay chu chu thich ben duoi KHONG duoc ghi "business days" (sua 18.08.2026:
   truoc day ghi "business days" trong khi phep tinh la ngay lich -> chu mot dang,
   so mot neo).

   SUA 26.08.2026 — CLAUDE_IBUYTERO_SHIPPING_MESSAGE_FIX_ONLY.md (P0, Section
   3/4/8): go dong "Estimated Delivery" + "Production 2–6 days + transit 7–11
   days" khoi ca ngan gio hang (ham build() duoi day) VA trang /cart (ham
   paintCartPage() duoi day). Ly do: chuoi ngay/khoang ngay tinh tay nay mau
   thuan voi thong diep moi da duyet ("Made to Order — Ships in 1–2 Business
   Days", khong con ETA giao hang tinh san). Khoi .ibt-cp__deliv trong
   sections/main-cart.liquid VAN CON [hidden] mac dinh trong Liquid — o day chi
   khong con go thuoc tinh do ra nua, nen khong can sua file Liquid.
   De khoi phuc (reversible): xem lich su file nay truoc 26.08.2026, hoac doc
   lai doan da go trong CLAUDE_IBUYTERO_SHIPPING_MESSAGE_FIX_ONLY.md.
   D_START/D_END/deliveryRange() giu nguyen (khong con noi nao goi toi) de giam
   thieu thay doi va de khoi phuc neu can.

   SUA 27.08.2026 — IUX_IBUYTERO_CART_DRAWER_POLISH.md (P1 polish, Section
   2/3/4): (a) chuan hoa chu shipping — "Free US Shipping" -> "Free U.S.
   Shipping" trong TRUST, giu dung en-dash "1–2" (truoc day la hyphen thuong
   "1-2"); (b) hang tin cay "Printed & Sewn by Us" -> "Printed, Cut & Sewn by
   Us" (khop dung Section 3, khong them Made in USA / Ships from USA / US
   warehouse / US manufacturer); (c) go dong nho "Free US Shipping on every
   order" (.ibt-cd__note) ngay duoi hang "Shipping — FREE" trong ham build() —
   Section 4 goi day la dong lap lai thong diep free-shipping da co o dong dau
   ("Free U.S. Shipping") va o hang tin cay, nen bo cho gon.
   ⚠ Trang /cart (sections/main-cart.liquid) co MOT khoi Liquid tinh rieng, sao
   y het cau truc nay ("Shipping — FREE" + dong .ibt-cd__note giong het, va
   danh sach tin cay rieng bon dong khac gom "Made to Order") — file Liquid do
   KHONG duoc sua trong dot nay vi chi thi IUX chi noi ro pham vi "Cart Drawer",
   khong nhac toi trang /cart. Da bao lai cho chu store trong bao cao IUX de xin
   quyet dinh rieng.
   ========================================================================== */
(function () {
  var D_START = 9;   // giong block delivery_time tren PDP
  var D_END = 17;
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  /* SUA 18.08.2026 — them dau phay hang nghin.
     Truoc day tra ve "$1234.50" trong khi bo loc `money` cua Shopify (dung o trang
     /cart) tra ve "$1,234.50" -> cung mot gio hang, hai kieu so o hai man hinh.
     Cung bo luon phan noi ma tien te o day: dong "Estimated Total" da tu noi
     ' USD' roi, de ca hai thi shop khac USD se ra "…  EUR EUR". */
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v.join('.');
  }

  function deliveryRange() {
    var a = new Date(); a.setDate(a.getDate() + D_START);
    var b = new Date(); b.setDate(b.getDate() + D_END);
    var f = function (d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); };
    return f(a) + ' – ' + f(b);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Hang tin hieu tin cay — Spec 05 muc "Trust" liet ke dung 5 dong nay.
     Mau lay tu 00_GLOBAL_DESIGN_SYSTEM: dau tich #2A3E2C, chu #55524D.
     SUA 27.08.2026 (IUX_IBUYTERO_CART_DRAWER_POLISH.md Section 2/3): "Free US
     Shipping" -> "Free U.S. Shipping"; "1-2" -> "1–2" (en-dash); "Printed &
     Sewn by Us" -> "Printed, Cut & Sewn by Us". */
  var TRUST = ['Free U.S. Shipping', 'Ships in 1–2 Business Days', 'Printed, Cut & Sewn by Us', '30-Day Easy Returns', 'Secure Checkout'];

  function checkSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function buildTrust() {
    var li = '';
    for (var i = 0; i < TRUST.length; i++) {
      li += '<li><span class="ibt-cd__tick">' + checkSvg() + '</span>' + esc(TRUST[i]) + '</li>';
    }
    return '<ul class="ibt-cd__trust list-unstyled">' + li + '</ul>';
  }

  /* SUA 28.08.2026 — IUX_IBUYTERO_PRICE_SHIPPING_CONTROLLED_TEST_V1.md muc 12:
     4 SP test $49.99 da bi loai khoi ma "Buy 2+ Save 15%" (discountAutomaticBasicUpdate).
     Banner/thanh tien do o duoi TRUOC DAY chi doan theo SO LUONG (qty), khong biet
     san pham nao con duoc giam that -> hua suong tren dung 4 trang do. Nay doi sang
     doc BANG CHUNG THAT tu Shopify (cart.cart_level_discount_applications /
     cart.total_discount) cho truong hop qty>=2, va kiem product_id cho truong hop
     qty===1 (luc do CHUA co giam gia nao de doc, phai biet truoc san pham co nam
     trong danh sach loai tru hay khong). */
  var IBT_V1_TEST_PIDS = [8239973761093, 8239961145413, 8239876800581, 8241149116485];

  function build(cart) {
    var qty = cart.item_count || 0;
    var apps = cart.cart_level_discount_applications || [];
    var hasRealDiscount = apps.length > 0 || (cart.total_discount || 0) > 0;
    var firstPid = (cart.items && cart.items.length === 1) ? cart.items[0].product_id : null;
    var isSingleTestItem = firstPid !== null && IBT_V1_TEST_PIDS.indexOf(firstPid) !== -1;

    var promo = (qty >= 2 && hasRealDiscount)
      ? '<div class="ibt-cd__promo"><span class="ibt-cd__tag" aria-hidden="true">' + tagSvg() + '</span>' +
        '<span><strong>Buy 2, Save 15%</strong><span>Discount will be applied automatically at checkout.</span></span></div>'
      : (qty === 1 && !isSingleTestItem
          ? '<div class="ibt-cd__promo ibt-cd__promo--nudge"><span class="ibt-cd__tag" aria-hidden="true">' + tagSvg() + '</span>' +
            '<span><strong>Add one more pajama set to save 15%</strong><span>The 15% discount applies automatically from 2 items.</span></span></div>'
          : '');

    /* SUA 18.08.2026 — Subtotal doi tu `items_subtotal_price` sang
       `original_total_price` (gia TRUOC MOI khuyen mai).
       Vi sao: `items_subtotal_price` la tong gia dong SAU khuyen mai muc DONG. Neu
       cua hang bat mot khuyen mai muc dong thi so do da bi tru san, ma dong "giam
       gia" ben duoi lai khong hien (khuyen mai muc dong khong nam trong
       cart_level_discount_applications) -> khach khong thay minh duoc giam bao nhieu.
       Lay gia GOC lam Subtotal thi phep tru luon khop: Subtotal - cac dong giam =
       Estimated Total.
       ⚠ HOM NAY HAI TRUONG NAY BANG NHAU (da do that: ca hai deu 22500 voi gio 3
       mon $75) nen so hien ra KHONG DOI; day la sua de chong lo cho tuong lai. */
    var rows =
      '<div class="ibt-cd__row"><span>Subtotal (' + qty + (qty === 1 ? ' item' : ' items') + ')</span>' +
      '<span>' + money(cart.original_total_price) + '</span></div>';

    /* SUA 18.08.2026: truoc day gop moi khuyen mai vao MOT dong ghi cung chu
       "Save 15%". Neu cua hang chay hai chuong trinh cung luc thi dong do vua sai
       ten vua gop nham so. Nay in DUNG mot dong cho moi khuyen mai, TEN lay tu
       Shopify (d.title), SO lay tu d.total_allocated_amount. */
    var shown = 0;
    for (var i = 0; i < apps.length; i++) {
      var amt = apps[i].total_allocated_amount || 0;
      if (amt <= 0) continue;
      shown++;
      rows += '<div class="ibt-cd__row ibt-cd__row--save"><span>' + esc(apps[i].title || 'Discount') +
              '</span><span>-' + money(amt) + '</span></div>';
    }
    /* Luoi do: khuyen mai muc DONG khong xuat hien trong cart_level_discount_applications.
       Khi do van con `total_discount` cua Shopify (= tong moi khuyen mai) de hien
       mot dong gop. Khong tu cong tru gi — doc thang mot truong cua Shopify. */
    if (shown === 0 && (cart.total_discount || 0) > 0) {
      rows += '<div class="ibt-cd__row ibt-cd__row--save"><span>You are saving</span><span>-' +
              money(cart.total_discount) + '</span></div>';
    }

    /* SUA 28.08.2026 — IUX_IBUYTERO_PRICE_SHIPPING_CONTROLLED_TEST_V1.md muc 11:
       Truoc day dong nay ghi CHET "FREE" (dung tu hoi chinh sach cu la mien phi
       toan bo). Chinh sach that hien tai la $6.99 duoi $99, free tu $99+ (da doi
       trong Shopify Settings > Shipping) — phai TINH LAI theo cart.total_price,
       khong duoc ghi chet nua. Nguong/gia lay dung theo cau hinh that dang chay,
       sua o day thi phai sua CA sections/main-cart.liquid (cung mot cong thuc). */
    var IBT_SHIP_THRESHOLD = 9900; // $99.00, dong voi Settings > Shipping and delivery
    var IBT_SHIP_FLAT = 699;       // $6.99
    var shipAmt = cart.total_price >= IBT_SHIP_THRESHOLD ? 0 : IBT_SHIP_FLAT;
    rows +=
      '<div class="ibt-cd__row"><span>Shipping</span><span>' + (shipAmt === 0 ? 'FREE' : money(shipAmt)) + '</span></div>' +
      '<div class="ibt-cd__row ibt-cd__row--total"><span>Estimated Total</span><span>' +
      money(cart.total_price + shipAmt) + ' ' + esc(cart.currency || 'USD') + '</span></div>';

    /* SUA 18.08.2026: truoc day co ghi chu noi "mockup ngan gio hang KHONG co hang
       tin cay" roi bo han. Nhan dinh do SAI (mockup 05 co the anh xuong + 3 dong
       tin cay o goc duoi), va Spec 05 muc "Trust" liet ke ro 5 dong. Nay dung lai. */
    return '<div class="ibt-cd" data-ibt-cd>' + promo +
           '<div class="ibt-cd__summary">' + rows + '</div>' + buildTrust() + '</div>';
  }

  /* Thanh tien do "Buy 2, Save 15%" — dat o dau ngan, dung mockup.
     SUA 28.08.2026 (muc 12 file IUX gia+ship): cung logic voi build() o tren —
     doc BANG CHUNG THAT (cart.cart_level_discount_applications / total_discount)
     cho qty>=2 thay vi doan theo so luong; kiem product_id loai tru cho qty===1.
     qty>=2 nhung KHONG co giam gia that (vd 2 san pham deu nam trong 4 SP test) ->
     an han thanh tien do, khong noi "mo khoa" lan "them 1 mon" (ca hai deu sai). */
  function buildBar(cart) {
    var qty = cart.item_count || 0;
    var apps = cart.cart_level_discount_applications || [];
    var hasRealDiscount = apps.length > 0 || (cart.total_discount || 0) > 0;
    if (qty >= 2 && hasRealDiscount) {
      return '<div class="ibt-cdbar" data-ibt-cdbar>' +
        '<p class="ibt-cdbar__label">🎉 You unlocked 15% off!</p>' +
        '<div class="ibt-cdbar__track"><div class="ibt-cdbar__fill" style="width:100%"></div></div></div>';
    }
    var firstPid = (cart.items && cart.items.length === 1) ? cart.items[0].product_id : null;
    var isSingleTestItem = firstPid !== null && IBT_V1_TEST_PIDS.indexOf(firstPid) !== -1;
    if (qty === 1 && !isSingleTestItem) {
      return '<div class="ibt-cdbar" data-ibt-cdbar>' +
        '<p class="ibt-cdbar__label">Add 1 more pajama set to get 15% off!</p>' +
        '<div class="ibt-cdbar__track"><div class="ibt-cdbar__fill" style="width:50%"></div></div></div>';
    }
    return '';
  }

  /* Dong tuy chon cua tung san pham.
     Theme chi in TEN BIEN THE tho ("M", hoac "M / Pink" khi co nhieu tuy chon).
     Mockup muon tach thanh tung dong co nhan: "Size: M", "Color: Pink".
     Doc TEN tuy chon that tu /cart.js (options_with_values) nen khi cua hang
     them bien the MAU sau nay, dong "Color: ..." tu dong xuat hien, khong phai
     sua gi them. */
  function labelOptions(cart) {
    var rows = document.querySelectorAll('.halo-cart-sidebar .previewCartList > *');
    for (var i = 0; i < rows.length; i++) {
      var item = (cart.items || [])[i];
      var box = rows[i].querySelector('.previewCartItem-variant');
      if (!item || !box) continue;
      var opts = item.options_with_values || [];
      var html = '';
      for (var j = 0; j < opts.length; j++) {
        var n = String(opts[j].name || '').trim();
        var v = String(opts[j].value || '').trim();
        if (!v || v === 'Default Title' || n === 'Title') continue;
        html += '<span class="ibt-cd__opt"><em>' + esc(n) + ':</em> ' + esc(v) + '</span>';
      }
      if (!html) continue;
      box.setAttribute('data-ibt-opt', '');
      if (box.innerHTML !== html) { box.innerHTML = html; }
    }
  }

  function setTitle(cart) {
    var t = document.querySelector('.halo-cart-sidebar .halo-sidebar-header .title');
    if (!t) return;
    var want = 'Your Cart (' + (cart.item_count || 0) + ')';
    if (t.textContent.trim() !== want) { t.textContent = want; }
  }

  function tagSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg>';
  }

  var busy = false;
  var observer = null;      // giu de NGAT khi chinh minh sua DOM
  var lastSig = '';         // chu ky gio hang lan ve gan nhat

  function paint(cart, host) {
    if (observer) observer.disconnect();
    try {
      var old = document.querySelector('.halo-cart-sidebar [data-ibt-cd]');
      if (old) old.remove();
      var oldBar = document.querySelector('.halo-cart-sidebar [data-ibt-cdbar]');
      if (oldBar) oldBar.remove();
      if (!cart.item_count) return;
      setTitle(cart);
      labelOptions(cart);
      host.insertAdjacentHTML('beforebegin', build(cart));
      var wrap = host.closest('.previewCart-wrapper');
      if (wrap) {
        wrap.insertAdjacentHTML('afterbegin', buildBar(cart));
        // Mockup khong co khoi "You May Also Like" xen giua san pham va bang
        // tom tat. Khong xoa (van co gia tri ban them) — chi day xuong DUOI
        // nut CHECK OUT de duong di ket thuc don khong bi ngat quang.
        var xsell = wrap.querySelector('.previewCartCollection');
        if (xsell && xsell.parentElement !== wrap) { wrap.appendChild(xsell); }
      }
    } finally {
      connect();
    }
  }

  /* SUA 18.08.2026 — TIEU DE NGAN KHI GIO RONG.
     Ban cu bat dau bang `var host = ...previewCartAction; if (!host) return;`.
     Nhanh gio RONG cua halo-side-cart.liquid KHONG in ra .previewCartAction, nen
     ham thoat TRUOC khi kip goi setTitle() -> tieu de van la chu goc "Shopping
     Cart" thay vi "Your Cart (0)".
     Nay: dieu kien vao ham la co NGAN (.halo-cart-sidebar); dat tieu de luon luon;
     chi phan VE khoi tom tat moi can .previewCartAction. */
  function render(force) {
    var side = document.querySelector('.halo-cart-sidebar');
    if (!side || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sig = cart.item_count + '|' + cart.items_subtotal_price + '|' + cart.total_price;
        setTitle(cart);   // theme dung lai tieu de goc moi lan ve lai ngan
        var host = side.querySelector('.previewCartAction');
        if (host) {
          var present = !!document.querySelector('.halo-cart-sidebar [data-ibt-cd]')
                     && !!document.querySelector('.halo-cart-sidebar [data-ibt-opt]');
          // Chi ve lai khi gio hang THAT SU doi (hoac khoi bi theme xoa mat).
          // Neu khong se ve lai lien tuc vi chinh minh lam DOM thay doi.
          if (force || sig !== lastSig || (!present && cart.item_count)) {
            lastSig = sig;
            paint(cart, host);
          }
        } else {
          lastSig = sig;
        }
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  function connect() {
    var side = document.querySelector('.halo-cart-sidebar');
    if (!side) return;
    if (!observer) {
      observer = new MutationObserver(function () { setTimeout(render, 150); });
    }
    observer.observe(side, { childList: true, subtree: true });
  }

  // Ve lai khi: mo ngan gio hang, hoac danh sach san pham trong ngan doi
  function watch() {
    if (!document.querySelector('.halo-cart-sidebar')) return;
    render(true);
    connect();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-sidebar], .halo-cart-sidebar, a[href*="/cart"]')) {
        setTimeout(function () { render(true); }, 600);
      }
    }, true);
  }

  /* ------------------------------------------------------------------------
     TRANG /cart — chi hai viec, xem dau file.
     ------------------------------------------------------------------------ */
  var pageBusy = false;

  function paintCartPage() {
    // (a) NGAY GIAO — DA GO 26.08.2026 theo CLAUDE_IBUYTERO_SHIPPING_MESSAGE_FIX_ONLY.md
    //     Section 3/4/8: khong con dien/mo khoi "Estimated Delivery" + "Production
    //     2-6 days + transit 7-11 days" o trang /cart. Khoi .ibt-cp__deliv trong
    //     sections/main-cart.liquid van con thuoc tinh [hidden] mac dinh trong
    //     Liquid — o day chi don gian la khong con go bo thuoc tinh do nua, nen
    //     khoi luon luon an. Khong can/khong sua sections/main-cart.liquid.
    //     De khoi phuc: xem lich su file nay truoc 26.08.2026.
    // (b) SO LUONG TRONG TIEU DE — theme.js chi ve lai .page-header khi gio RONG.
    var h1 = document.querySelector('.template-cart .page-header[data-ibt-count]');
    if (!h1 || pageBusy) return;
    pageBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var base = h1.getAttribute('data-ibt-count-label') || 'Your cart';
        var want = base + ' (' + (cart.item_count || 0) + ')';
        if (h1.textContent.trim() !== want) h1.textContent = want;
        pageBusy = false;
      })
      .catch(function () { pageBusy = false; });
  }

  function watchCartPage() {
    var root = document.querySelector('.template-cart [data-cart]');
    if (!root) return;
    paintCartPage();
    // theme.js updateCart() ve lai `[data-cart-content] .cart` va cac dong tong
    // tien sau moi lan doi so luong -> the [data-ibt-deliv] moi tro ve gia tri
    // Liquid, phai dien lai.
    // GOP NHIP (debounce): mot lan ve lai cua theme sinh HANG CHUC lan bao thay doi.
    // Dung MOT dong ho duy nhat, dat lai moi lan co thay doi.
    // Da DO THAT: mot lan bam nut "+" van sinh 3 lan goi /cart.js du de 150ms hay
    // 500ms — vi theme.js ghi DOM lam BA DOT cach nhau hang GIAY (dot 1 gan lop
    // phu "dang tai", dot 2 thay noi dung khi ajax ve, dot 3 o buoc `complete`).
    // 3 lan goi mot tep JSON ~1KB cho moi lan doi so luong: chap nhan duoc.
    // (Khong doc so tu the [data-cart-count] o dau trang cho khoi phai goi mang:
    //  theme.js chi ghi so do o buoc `complete`, chay SAU buoc `success` sua DOM,
    //  nen doc som la ra so CU. Goi /cart.js thi khong bao gio bi vay.)
    var timer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(paintCartPage, 500);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function boot() { watch(); watchCartPage(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
